import React, { useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CommonModal, CustomPagination } from 'components'
import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { AddEditVehicleGroupModal, AddEditVendors, AddEditZoneModal } from 'modals';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { deleteZoneData, getZoneListData } from '_services/accountsServices/zoneServices';

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { constant } from 'constants/constant';
import { deleteVehicleGroupData, getVehicleGroupListData } from '_services/accountsServices/vehicleGroupServices';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';

const VehicleGroup = () => {
  useDocumentTitle("Vehicle Group | T360");

  const { settingChild } = useContext(UserContext);
  const settingChildVehicleGrp = settingChild?.find((i) => i?.label === "Vehicle Group");
  const [isOpenZoneModal, setIsOpenZoneModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [zoneList, setZoneList] = useState([])
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const prevFilterRef = useRef();
  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: '',
    status: 1
  });

  const toggleZoneModal = () => {
    setIsOpenZoneModal(!isOpenZoneModal);
  };

  const getDataVehicleGroupList = async () => {
    try {
      setLoading(true);
      let object = {
        ...filter,
        company_id: StorageService.getCompanyId(),
      }
      const res = await getVehicleGroupListData(object);
      if (res?.responseCode == 200) {
        setZoneList(res?.data?.vehicle_group_list);
        setTotalItems(res?.data?.total_record);
      }
    } catch (error) {
      // throw error;
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {

    const prevFilter = prevFilterRef.current;
    if (
      JSON.stringify(prevFilter) !== JSON.stringify(filter)
    ) {
      getDataVehicleGroupList();
      prevFilterRef.current = filter;
    }

  }, [filter, isOpenZoneModal])

  const deleteHandler = (item) => {
    setIsDelete(item)
  }

  const submitDeleteVehicleGroup = async () => {
    setLoading(true);
    try {
      let object = {
        company_id: isDelete?.company_id,
        vehicle_group_id: isDelete?._id,
      }
      const res = await deleteVehicleGroupData(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataVehicleGroupList();
        setLoading(false);
        setIsDelete(false);
      } else {
        toast.success('Error !! ');
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteVehicleGroup,
    isLoadding: loading,
  }

  let openZoneModal = {
    isOpen: isOpenZoneModal,
    closeModal: (e) => setIsOpenZoneModal(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: isOpenZoneModal?.isDetails ? "View Vehicle Group" : 'Add Vehicle Group',
    submitTitle: isOpenZoneModal?.isDetails ? "View Vehicle Group" : 'Add Vehicle Group',
    footerPart: isOpenZoneModal?.isDetails ? true : false,
    hideFooterSumbmitBtn: isOpenZoneModal?.isDetails ? true : false,
    hideCompletelyFoolter: isOpenZoneModal?.isDetails ? true : false,
    ApiCall: getDataVehicleGroupList
  }

  const columns = [
    // { header: "", accessor: "serial" },
    { header: "Vehicle Group Name", accessor: "vehicle_group_name" },
    { header: "No. of Vehicle", accessor: "vehicle_no" },
    { header: "Status", accessor: "status" },
    { header: "Action", accessor: "action" }
  ];

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      // serial: <>{i + 1 + filter?.limit * (filter?.page - 1)}</>,
      serial: <>
        <div className="signDropdown">
          <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button>
          <div className="dropdownContent">
            {settingChildVehicleGrp?.view === 1 && <div onClick={(e) => setIsOpenZoneModal({ ...item, isDetails: true })}
              className='_avPointer'
              style={{ textDecoration: 'none' }}

            >
              <span className='_samAnchor'>
                <span className='viewIcon_avt'>
                  <AiOutlineEye />
                </span>View
              </span>
            </div>}

            {settingChildVehicleGrp?.edit === 1 && <div
              // onClick={(e) => editHandler(item)}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='editIcon_avt'>
                  <FiEdit />
                </span>
                Edit
              </span>
            </div>}

            {settingChildVehicleGrp?.delete === 1 && <div
              onClick={(e) => deleteHandler(item)}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='deleteIcon_avt'>
                  <FaRegTrashCan color='red' />
                </span>
                Delete
              </span>
            </div>}
          </div>
        </div>
      </>,
      vehicle_group_name: <>{item?.name ? item?.name : '-'}</>,
      number_of_unit: <>{item?.contact_nunber ? item?.contact_nunber : '-'}</>,
      number_of_consignee: <>{item?.consignor_group_id?.name ? item?.consignor_group_id?.name : '-'}</>,
      status: <div style={{ color: item?.active ? "green" : "red" }}>  {item?.active ? constant.activeArray[item?.active] : '-'} </div>,
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "100px" }}
        >
          {settingChildVehicleGrp?.view === 1 && <div onClick={(e) => setIsOpenZoneModal({ ...item, isDetails: true })}
            className='_avPointer'
            style={{ textDecoration: 'none' }}

          >
            <span className='_samAnchor'>
              <span className='viewIcon_avt'>
                <AiOutlineEye color='green' />
              </span>
            </span>
          </div>}

          {settingChildVehicleGrp?.edit === 1 && <div
            // onClick={(e) => editHandler(item)}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='editIcon_avt'>
                <FiEdit color='blue' />
              </span>

            </span>
          </div>}

          {settingChildVehicleGrp?.delete === 1 && <div
            onClick={(e) => deleteHandler(item)}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='deleteIcon_avt'>
                <FaRegTrashCan color='red' />
              </span>

            </span>
          </div>}
        </div>
      ),
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  return (
    <div className="__profilCmp_main setting-nw-parentBx">
      <ButtonHeading
        title={"Vehicle Group"}
        onClick={toggleZoneModal}
        buttonTitle={settingChildVehicleGrp?.create === 1 && "Add Vehicle Group"}
        className="commonHeading_title"
        showSearchFilter={{ search: true, filterOption: false, filterCount: true }}
        onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
        filter={filter}
        setFilter={setFilter}
        isDebouncedSearch={true}
      />

      <div className='_tabWith_outTab'>
        <BootstrapTable
          tableClass="nrml-tbl"
          columns={columns}
          data={rowListData(zoneList?.length > 0 ? zoneList : [])}
          isLoading={loading}
        />

        {zoneList?.length && <div className='paginationFt_avt'>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div>}
      </div>

      {
        isOpenZoneModal
        && (
          <AddEditVehicleGroupModal {...openZoneModal} />
        )
      }

      {
        isDelete?.company_id && (
          <CommonModal {...propsObject}>
            <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
          </CommonModal>
        )
      }

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? 'visible' : 'hidden' }}
      >
        {showFilterModal &&
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        }
      </div>
      <div className={showFilterModal ? 'offBack_drop' : ''}></div>

    </div>
  )
}

export default VehicleGroup